module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('line-chart', {
    attrs: {
      "chart-data": _vm.datacollection
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.fillData()
      }
    }
  }, [_vm._v("Randomize")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-54e65f1a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoChartLine.vue
// module id = 3766
// module chunks = 1